import { css } from 'emotion';

import { colors, fonts } from '../styles';

export const wrapper = css`
  position: relative;
  z-index: 0;

  display: flex;
  justify-content: space-between;

  width: 100%;

  /* Overriding user agent style sheet */
  /* TODO: get a better normalize/reset.css */
  padding: 0;

  &::before {
    content: "";
    display: inline-block;

    position: absolute;
    top: 12px;
    left: 50%;
    transform: translate(-50%, -50%);

    z-index: -10;

    width: calc(100% - 24px);
    height: 1px;

    background-color: ${colors.gray.light};
  }
`;

export const step = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 24px;
`;

export const bullet = css`
  position: relative;

  width: 22px;
  height: 22px;

  background-color: ${colors.white};
  border: solid 1px ${colors.gray.light};
  border-radius: 50%;

  &::before {
    content: "";
    display: inline-block;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 8px;
    height: 8px;
    border-radius: 50%;

    background-color: ${colors.gray.light};
  }
`;

export const icon = css`
  width: 16px;
  height: 16px;
  color: ${colors.white};

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scaleX(-1);

  opacity: 0;
`;

export const label = css`
  font-size: ${fonts.size.small};
  color: ${colors.gray.light};
  white-space: nowrap;
  margin-top: 5px;
`;

export const current = css`
  .${bullet} {
    box-shadow: 2px 2px 10px 0 ${colors.shadows.default};
    transition: box-shadow 0.4s ease;

    &::before {
      background-color: ${colors.primary.default};
      transition: background-color 0.4s ease;
    }
  }

  .${label} {
    color: ${colors.gray.dark};
    font-weight: ${fonts.weight.medium};
  }
`;

export const completed = css`
  .${bullet} {
    transform: rotateY(180deg);
    background-color: ${colors.primary.default};
    border-color: ${colors.primary.default};
    transition:
      background-color 0.3s ease 0.1s,
      border-color 0.3s ease 0.1s,
      transform 0.4s ease;

    &::before {
      opacity: 0;
      transition: opacity 0.4s ease;
    }
  }

  .${icon} {
    opacity: 1;
    transition: opacity 0.3s ease 0.1s;
  }

  .${label} {
    color: ${colors.primary.default};
  }
`;

export const finished = css`
  &:last-child .${label} {
    font-weight: 500;
  }
`;
